import { createFileRoute } from '@tanstack/react-router'
import { ForgotPasswordScreen } from '@/features/auth/routes/forgot-password-screen'

export const Route = createFileRoute('/forgot-password')({ component: ForgotPasswordScreen })
